import {Pipe, PipeTransform} from '@angular/core';

/*
 * Converts strings into snake_case format
 */
@Pipe({ name: 'nlAfterP' })
export class NlAfterPPipe implements PipeTransform {
    transform(value: string): string {
        if (value) {
            return value.replace(new RegExp('</p>', 'g'), '</p>\n');
        }
   }
}
